Namespace('Monitoring.SharedSessions')

class Monitoring.SharedSessions.SharedSessionSidebarView extends Backbone.View
  template: JST["backbone/templates/monitoring/shared_sessions/shared_session_sidebar"]
  className: 'shared-session-sidebar'
  id: 'myNav'

  initialize: (@options = {}) ->
    @opened = false
    @currentFilterDefinition = @options.filter_definition
    @filtersView = new Monitoring.Views.SocialContents.Filters.FiltersView(@options.filtersViewOptions)

  render: ->
    @$el.html(@template(@currentFilterDefinition))
    # TODO use this to select the correct time
    # @$el.find("#realtime_cbo option[value=#{@searchQuery.get('date_from_realtime').value}]").prop('selected', true)
    @renderFilters()
    @

  renderFilters: ->
    temp = @filtersView.render().$el
    @$el.find('.shared-session-applied-filters-container').html(temp)

  toggle: ->
    if @opened then @close() else @open()

  open: ->
    @$el.css({ left: "0" })
    @opened = true
    @trigger('open-filter')

  close: ->
    @$el.css({ left: "-300px" })
    @opened = false
    @trigger('close-filter')

  refresh: (filtersViewOptions) ->
    @filtersView = new Monitoring.Views.SocialContents.Filters.FiltersView(filtersViewOptions)
    @renderFilters()
    @